'use strict';

var path = require('path');

function replaceExt(npath, ext) {
  if (typeof npath !== 'string') {
    return npath;
  }

  if (npath.length === 0) {
    return npath;
  }

  var nFileName = path.basename(npath, path.extname(npath)) + ext;
  return path.join(path.dirname(npath), nFileName);
}

module.exports = replaceExt;



//////////////////
// WEBPACK FOOTER
// ./~/replace-ext/index.js
// module id = 296
// module chunks = 104158497352714 142496547410815 230539012308250